import table from './widgets/table';

export default [table];
